import { CompButtonCore } from '../core/button/comp'

export const CompButton = CompButtonCore
